// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"f64814a7","158":"ec63d9ad","183":"87f3a698","266":"beb8fe2a","369":"70d28db2","387":"1b2260dc","485":"94fa0cb7","488":"34923e53","560":"80d7085b","644":"e18499cd","776":"6794aa61","921":"0c5f3801"}[chunkId] + ".chunk.js";
};